import $ from "jquery";
import Marquee from "../src/Marquee";

const classic_marquee = new Marquee($(".marquee-section__photos")[0], {
  speed: 1,
  direction: "left",
});
